"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeManagerImpl = void 0;
var rxjs_1 = require("rxjs");
var core_1 = require("@athena-portal/core");
var TreeManagerImpl = /** @class */ (function () {
    function TreeManagerImpl() {
        this.openSubject = new rxjs_1.BehaviorSubject([]);
    }
    TreeManagerImpl.prototype.subscribeToOpen = function (action) {
        return this.openSubject.subscribe(action);
    };
    TreeManagerImpl.prototype.addOpen = function (id) {
        var currentValue = this.openSubject.getValue();
        var newValue = __spreadArray(__spreadArray([], currentValue, true), [id].filter(function (x) { return !currentValue.includes(x); }), true);
        if (newValue.length !== currentValue.length) {
            this.openSubject.next(newValue);
        }
    };
    TreeManagerImpl.prototype.changeOpen = function (value) {
        this.openSubject.next(value);
    };
    TreeManagerImpl = __decorate([
        (0, core_1.injectable)(),
        __metadata("design:paramtypes", [])
    ], TreeManagerImpl);
    return TreeManagerImpl;
}());
exports.TreeManagerImpl = TreeManagerImpl;
//# sourceMappingURL=TreeManagerImpl.js.map